import "../styles/Recipe.css";
import "../styles/Buttons.css";

import React from "react";
import { Link } from "react-router-dom";

function TopNavbar(props) {
  const {
    title,
    rbuttonIcon,
    lbuttonIcon,
    rbuttonHref,
    lbuttonHref,
    rbackground,
    lbackground,
    rfunction,
    lfunction,
  } = props;

  return (
    <div className="spc-between topnav-container">
     
        {rbuttonIcon.map((icon, index) => (
          <Link to={rbuttonHref[index]} key={index} href={rbuttonHref[index]} onClick={rfunction}>
            <div className={rbackground}>
              <span className={icon}></span>
            </div>
          </Link>
        ))}

      <p className="heading-1">{title}</p>

      <div className={lbackground}>
        {lbuttonIcon.map((icon, index) => (
          <Link to={rbuttonHref[index]} key={index} href={lbuttonHref[index]} onClick={lfunction}>
            <span className={icon}></span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TopNavbar;